
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-parts/vehicle/[vehicle]",
      function () {
        return require("private-next-pages/auto-parts/vehicle/[vehicle].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-parts/vehicle/[vehicle]"])
      });
    }
  